<script setup lang="ts">
definePageMeta({
  name: 'journals-index',
  layout: 'default',
  colorMode: 'light',
  theme: 'blurple',
  breadcrumb: { label: 'Tidsskrifter' },
  title: 'Tidsskrifter',
})

useSeoMeta({
  title: 'Tidsskrifter',
  description: 'Finn tidsskrifter',
})

useHead({
  bodyAttrs: { class: 'bg-surface-secondary' },
})

const { filteredJournals, isLoading, suspense } = useJournalFilters()

if (import.meta.server) {
  await suspense()
}

const route = useRoute<'journals-index'>()

useTrackLastActivity(() => String(route.meta.title))
</script>

<template>
  <NuxtLayout name="overview-with-bread-crumbs-and-title" page-title="Tidsskrifter" sticky-panel-top>
    <template #background-illustration>
      <IllustrationTidsskrifter />
    </template>

    <div class="w-full flex items-start gap-l">
      <StickyContent class="hidden md:flex flex-col shrink-0 max-h-[calc(100dvh-6.5rem)] no-scrollbar overflow-y-auto [--padding-top:0rem]">
        <JournalsFilterSidebar />
      </StickyContent>

      <div class="@container flex-1 min-w-0 flex flex-col gap-2xs">
        <StickyContent class="bg-white z-10 pt-m">
          <JournalsListHeader />
        </StickyContent>

        <h2 class="sr-only">Tidsskrifter</h2>

        <ul class="w-full grid justify-start grid-cols-1 @[500px]:grid-cols-2 @[750px]:grid-cols-3 gap-m" aria-label="Tidsskrifter">
          <template v-if="isLoading">
            <li v-for="index in 12" :key="index">
              <JournalsSkeleton />
            </li>
          </template>

          <template v-else-if="filteredJournals.length">
            <JournalsCard v-for="journal in filteredJournals" :key="journal.id" :journal="journal" />
          </template>

          <template v-else>
            <li class="col-span-full text-center text-text-secondary mt-xl list-none">
              Fant ingen tidsskrifter som matcher søket ditt.
            </li>
          </template>
        </ul>
      </div>
    </div>
  </NuxtLayout>
</template>
